<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">Detail {{ $t("chain") }}</h6>
                    <br>
                    <br>
                    <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm()"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                    </button>

                </div>

                <div class="card-body">

                    

                        <div class="row mb-3">

                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t("id")
                            }}</label>
                        </div>
                        <div class="col-lg-8">
                            
                            {{this.forms.buffer_id}}
                            
                        </div>
                        </div>
 
        
                    

                        <div class="row mb-3">

                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t("codeType")
                            }}</label>
                        </div>
                        <div class="col-lg-8">
                            
                            
                            {{this.forms.type}}
                            
                        </div>
                        </div>
                        

                        <div class="row mb-3">

                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t("statusTxt")
                            }}</label>
                        </div>
                        <div class="col-lg-8">

                            <div v-if="forms.seq > 0">
                                
                                {{this.$t('success')}}
                                
                            </div> 
                            <div v-else>
                                {{this.$t('error')}}
                            </div>
                        </div>



                        <div class="row mb-3">

                            <div class="col-lg-2">
                                <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("datas_structure")
                                }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                                <pre>{{this.prettyJson(this.forms.datas_structure)}}</pre> 

                            </div>
                        </div>
                        

                        <div class="row mb-3">

                            <div class="col-lg-2">
                                <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("datas_response")
                                }}</label>
                            </div>
                            <div class="col-lg-8">
                                 
                                <pre>{{this.prettyJson(this.forms.datas_response)}}</pre> 
                                
                            </div>
                        </div>

                        <div class="row mb-3">

                            <div class="col-lg-2">
                                <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("datas")
                                }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                                {{this.forms.datas}}
                                
                            </div>
                        </div>


                        <div class="row mb-3">

                            <div class="col-lg-2">
                                <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("datas_structure")
                                }}</label>
                            </div>
                            <div class="col-lg-8">
                                 
                                <pre>{{this.prettyJson(this.forms.datas_structure)}}</pre> 
                                
                            </div>
                        </div>
                        

                        <div class="row mb-3">

                            <div class="col-lg-2">
                                <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("created_at")
                                }}</label>
                            </div>
                            <div class="col-lg-8">
                                 
                                {{this.forms.created_at}}
                                
                            </div>
                        </div>

                        
                    </div>
 

  

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "BlujayChainDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      forms: {
        buffer_id:"",
        integration:"",
        filename:"",
        type:"",
        seq:"",
        datas:"",
        datas_structure:"",
        datas_response:"",
        datas_xml:"",
        datas_structure_xml:"",
        datas_response_xml:"",
        modified_at:"",
        created_at:"",
        updated_at:"",
      },
    };
  },
  watch: {},
  methods: {

    prettyJson(value){
        if(value){
            return JSON.stringify(JSON.parse(value), null, 2);
        }
        
    },
 
    backForm() {
      window.location.href = "/blujay/chain";
    },

    loadData() {
      this.isLoading = true;

        var params = this.$onBehind(this.$route.params.id);
      const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/buffers/detail/" + params[0];
      return this.$http.get(baseURI,{ timeout: 50000 }).then((response) => {
       this.isLoading = false;
        this.forms = response.data.datas;
 
      }).catch(error => {
          this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }else{

            if(error.code == "ECONNABORTED"){
              this.error("Please Check Your Internet Connection");
            }
      
            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }
            
          }


        });
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BlujayChainController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },
 
    logout(){

        const baseURI = this.$settings.endPoint + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
            
        console.log(response);

        });

        this.$logoutUser();
        window.location.href = '/';
    },
    
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.loadData();
    this.fetchIt();
  },
};
</script>
<style scoped>
.blur-content{
  filter: blur(5px); 
}
</style>